import { usePage } from "@inertiajs/react"
import { SubNav } from "@/components/SubNav"
import type { PageProps } from "@/types/inertia"

/**
 * The Weekly Reports module's tab strip.
 *
 * Every tab passes an explicit `active` predicate: the default match is a path
 * prefix, and "/weekly_reports" is a prefix of every other path in the module,
 * so without them Home would light up on all three.
 *
 * The Form tab is offered only with Edit on Weekly Reports. Presentation, never
 * access control — AppAccessGate refuses the form to Read only either way.
 *
 * There is no OrgSwitcher in the right-hand slot. A weekly report is personal —
 * it belongs to whoever filed it, not to the organization being viewed — and a
 * scope picker here would imply otherwise.
 */
export function WeeklyReportsSubNav() {
  const canEdit = usePage<PageProps>().props.app_access?.weekly_reports === "edit"

  const items = [
    {
      href: "/weekly_reports",
      label: "Home",
      active: (url: string) => url === "/weekly_reports" || url.startsWith("/weekly_reports?"),
    },
  ]

  if (canEdit) {
    items.push({
      href: "/weekly_reports/new",
      label: "Form",
      active: (url: string) =>
        url.startsWith("/weekly_reports/new") || /^\/weekly_reports\/\d+\/edit/.test(url),
    })
  }

  items.push({
    href: "/weekly_reports/mine",
    label: "Past Reports",
    active: (url: string) => url.startsWith("/weekly_reports/mine"),
  })

  return <SubNav ariaLabel="Weekly Reports sections" items={items} />
}
